// @flow
import type { PromoCampaign } from '../constants';

/**
 * Campaña «Verano Finect Plus»: código VERANOPLUS, 10%, hasta el 31 de agosto de 2026.
 *
 * Solo datos: lo que necesita saber la web en cualquier página (la precarga del SSR vive en el bundle
 * principal) para decidir si la campaña está viva. Su maqueta y sus textos están en views/Summer, que
 * se descarga aparte y solo cuando se pinta.
 *
 * Terminó el 31 de agosto de 2026 y se conserva por si vuelve el verano que viene: reactivarla es mover
 * las fechas de aquí, prorrogar el cupón en Stripe y encender su ajuste en dashboard2.
 */
export const veranoplus: PromoCampaign = {
  id: 'veranoplus',
  code: 'VERANOPLUS',
  discount: 10,
  // Sin fecha de arranque: la campaña se desplegó ya en marcha.
  startIso: null,
  // Último día si el backoffice no dice otra cosa. Los textos usan la fecha efectiva que devuelve
  // usePromoStatus, que puede venir prorrogada.
  endIso: '2026-08-31',
  setting: 'plus-promo-veranoplus',
  // `promotionName` viaja hasta la compra vía sessionStorage; `label` es el prefijo de las
  // creatividades (`plus-verano-hero`) y de las etiquetas de los eventos propios.
  ga4: { promotionName: 'verano_plus_2026', label: 'verano', pageId: 'verano-plus' }
};
